import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import walletReducer from "./slices/walletSlice";
import transactionReducer from "./slices/transactionSlice";
import kycReducer from "./slices/kycSlice";
import recoveryReducer from "./slices/recoverySlice";
import themeReducer from "./slices/themeSlice";
import recoveryChatReducer from "./slices/recoveryChatSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    wallet: walletReducer,
    transactions: transactionReducer,
    kyc: kycReducer,
    recovery: recoveryReducer,
    theme: themeReducer,
    recoveryChats: recoveryChatReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
